import Vue from 'vue';
import VueRouter from 'vue-router';
import SocialSharing from 'vue-social-sharing';

import App from './App.vue';

import store from './store';
import router from './routes';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(SocialSharing);

if (!Array.prototype.flat)
 Array.prototype.flat = function (depth = 1) {
   depth = isNaN(depth) ? 0 : Math.floor(depth);
   if (depth < 1) return this.slice();
   return [].concat(
      ...(depth < 2)
         ? this
         : this.map(v => Array.isArray(v) ? v.flat(depth - 1) : v)
   )
};

const app = new Vue({
  router,
  store,
  render: (createEle) => createEle(App),
}).$mount('#app-container');
